import React from 'react'

const Footer = () => {
  return (
    <div className='footer py-4 d-flex flex-lg-column' id='kt_footer'>
      <div className='container-fluid d-flex flex-column flex-md-row flex-stack'>
        <div className='text-dark order-2 order-md-1'>
          <span className='text-muted fw-bold me-2'>{new Date().getFullYear()} &copy;</span>
          <a href='#' className='text-gray-800 text-hover-primary'>
            Beneksus
          </a>
        </div>
      </div>
    </div>
  )
}

export {Footer}
